import { createApp } from 'vue';

import { useSearchArticles } from './hooks';

export const searchArticles = () => {
  const searchApp = document.getElementById('search-articles');
  if (!searchApp) return;
  const searchQuery = searchApp.dataset.query;
  if (!searchQuery) return;

  const app = createApp({
    setup() {
      const { posts, totalCount, canFetch, isLoading, isError, isInit, fetchPosts } =
        useSearchArticles(searchQuery);

      return { posts, totalCount, canFetch, isLoading, isError, isInit, fetchPosts };
    },
  });

  app.mount('#search-articles');
};
